import { Col, Form, Input, Row } from 'ui';

export type MemberProgramsListFiltersFormValues = {
  search?: string;
};

const MemberProgramsListFilters = () => (
  <Row>
    <Col span={24}>
      <Form.Item<MemberProgramsListFiltersFormValues> label="Search" name="search">
        <Input hasSearch />
      </Form.Item>
    </Col>
  </Row>
);

export default MemberProgramsListFilters;
